import { Component, inject, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { CreateFormsService } from '@bo-client/activation-management/shared/forms/create-forms.service';
import { PaymentTypeEnum } from '@bo-client/shared/constants/enums';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { MatRadioChange } from '@angular/material/radio';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { shareReplay } from 'rxjs/operators';
import { Einspeiservertrage } from '@bo-client/shared/config.model';
import { ValidatorsService } from '@bo-client/shared/forms/validators.service';

@Component({
  selector: 'app-economic-data',
  templateUrl: './economic-data.component.html',
  styleUrls: ['./economic-data.component.scss']
})
export class EconomicDataComponent implements OnInit {
  @Input() inputForm: FormGroup;
  @Input() error: boolean;
  @Input() canUpdate = false;

  private readonly validatorsService = inject(ValidatorsService);

  public paymentTypeEnum = PaymentTypeEnum;

  readonly feederContractConfig$ = this.dataShareService
    .getSingleTenantConfig$<Einspeiservertrage>('feederContract')
    .pipe(takeUntilDestroyed(), shareReplay(1));

  constructor(private createFormsService: CreateFormsService, private dataShareService: DataShareService) {}

  ngOnInit(): void {
    if (!(this.inputForm.get('invoiceContact') as FormArray).controls[0].get('mail').value) {
      (this.inputForm.get('invoiceContact') as FormArray).removeAt(0);
    }
    this.feederContractConfig$.subscribe((config) => {
      if (!!Object.keys(config).length && !config.sepaActivated) {
        this.inputForm.get('paymentType').patchValue(PaymentTypeEnum.BANKTRANSFER);
        this.inputForm.get('sepaMandate').get('acceptedSepa').clearValidators();
        this.inputForm.get('sepaMandate').get('acceptedSepa').patchValue(null);
      }
    });
  }

  changePaymentType(event: MatRadioChange) {
    if (event.value == this.paymentTypeEnum.DIRECTDEBIT) {
      this.inputForm
        .get('sepaMandate')
        .get('acceptedSepa')
        .setValidators([
          this.validatorsService.checkboxRequiredValidator(),
          this.createFormsService.mustTrue
        ]);
      this.inputForm.get('sepaMandate').get('acceptedSepa').markAsTouched();
    } else {
      this.inputForm.get('sepaMandate').get('acceptedSepa').clearValidators();
      this.inputForm.get('sepaMandate').get('acceptedSepa').patchValue(null);
      this.inputForm.get('sepaMandate').get('acceptedSepa').markAsTouched();
    }
    this.inputForm.get('sepaMandate').get('sepaAcceptedDate').patchValue(null);
  }

  changeDifferentInvoiceAddress(event: any) {
    if (event.checked) {
      const newItem: FormGroup = this.createFormsService.createContactDataForm({});
      this.createFormsService.applyZipCodeMaxLengthValidator(newItem);
      (this.inputForm.get('invoiceContact') as FormArray).push(newItem);
      this.inputForm.get('hasDifferentInvoiceContact').patchValue(true);
    } else {
      (this.inputForm.get('invoiceContact') as FormArray).removeAt(0);
      this.inputForm.get('hasDifferentInvoiceContact').patchValue(false);
    }
  }

  changeSepaConditions(event) {
    if (event) {
      this.inputForm.get('sepaMandate').get('sepaAcceptedDate').patchValue(new Date());
    } else {
      this.inputForm.get('sepaMandate').get('sepaAcceptedDate').patchValue(null);
    }
  }
}
